<div *transloco="let t; prefix: 'driver-table'" class="driver-table__container">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="importanceCounter"
    matSortDirection="asc"
    matSortDisableClear
    class="driver-table__table"
  >
    <colgroup class="driver-table__table-colgroup">
      <col />
      <col />
      <col />
      <col />
      <col />
    </colgroup>

    <ng-container matColumnDef="importanceCounter-top">
      <th mat-header-cell *matHeaderCellDef></th>
    </ng-container>

    <ng-container matColumnDef="driver-top">
      <th mat-header-cell *matHeaderCellDef></th>
    </ng-container>

    <ng-container matColumnDef="score-top">
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="2">
        <div *transloco="let it; read: 'metric-settings-form'" class="driver-table__score">
          {{ t('scoring', { scoring: it(scoringKey) }) }}
        </div>
      </th>
    </ng-container>

    <ng-container matColumnDef="actions-top">
      <th mat-header-cell *matHeaderCellDef></th>
    </ng-container>

    <ng-container matColumnDef="importanceCounter">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ t('importance') }}
      </th>

      <td mat-cell *matCellDef="let driver">
        {{ driver.importanceCounter }}
      </td>
    </ng-container>

    <ng-container matColumnDef="driver">
      <th mat-header-cell *matHeaderCellDef>
        {{ t('driver') }}
      </th>

      <td
        mat-cell
        *matCellDef="let driver"
        [matTooltip]="driver.fieldLongName"
        appShowMatTooltipIfTruncated
      >
        {{ driver.fieldLongName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="trend">
      <th mat-header-cell *matHeaderCellDef>{{ trendHeader }}</th>

      <td mat-cell *matCellDef="let driver">
        {{ driver.trend | number: numberPipeDigitInfo }}
      </td>
    </ng-container>

    <ng-container matColumnDef="score">
      <th mat-header-cell *matHeaderCellDef>
        {{ scoreHeader }}
      </th>

      <td mat-cell *matCellDef="let driver">
        {{ driver.current | number: numberPipeDigitInfo }}
      </td>
    </ng-container>

    <ng-container matColumnDef="simulated">
      <th mat-header-cell *matHeaderCellDef>
        {{ t('simulated') }}
      </th>

      <td mat-cell *matCellDef="let driver">
        <div class="driver-table__stepper-wrapper">
          <app-lex-horizontal-stepper
            [value]="driver.simulated ?? driver.current"
            [originalValue]="driver.current"
            [scale]="scale"
            [allowFractional]="predictiveOptions.decimals !== '0'"
            [allowNegative]="predictiveOptions.driverSettings.scoring === 'NPS'"
            [decimals]="+predictiveOptions.decimals"
            (valueChange)="onSimulatedValueChange($event, driver)"
          ></app-lex-horizontal-stepper>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let driver">
        <div [matMenuTriggerFor]="driverMenuTrigger" [matMenuTriggerData]="{ $implicit: driver }">
          <xi-icon-button color="CX" icon="kabob"></xi-icon-button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="TOP_COLUMNS; sticky: true"></tr>

    <tr mat-header-row *matHeaderRowDef="DISPLAYED_COLUMNS; sticky: true"></tr>

    <tr
      mat-row
      *matRowDef="let driver; columns: DISPLAYED_COLUMNS"
      (mouseenter)="onHover(driver)"
      (mouseleave)="onHover(null)"
    ></tr>
  </table>

  <mat-menu #driverMenuTrigger>
    <ng-template matMenuContent let-driver>
      <button
        mat-menu-item
        [disabled]="isDisabled || driver.simulated === null"
        (click)="onReset(driver)"
      >
        {{ t('reset') }}
      </button>

      @if (hasSmartSummaryFeature) {
        <button mat-menu-item [disabled]="isDisabled" (click)="onSmartSummary(driver)">
          {{ t('smart-summary') }}
        </button>
      }
    </ng-template>
  </mat-menu>
</div>
